import * as types from '../services/HoldCoType';

const initialState = {
  holdCoList: [],
  totalRecords: 0,
  isLoading: false,
  error: null,
  holdCoEdit: null,
  isEditLoading: false,
  editError: null,
  deleteSuccess: false,
  isDeleting: false,
  deleteError: null,
  deleteFileSuccess: false,
  deleteFileError: null,
  deletedFileId: null,
  saveSuccess: false,
  isSaving: false,
  saveError: null
};

const HoldCoReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_HOLDCO_LIST_REQUEST:
      return { ...state, isLoading: true, error: null };
    case types.GET_HOLDCO_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        holdCoList: action.payload.holdingCompanies || [],
        totalRecords: action.payload.totalRecords || 0
      };
    case types.GET_HOLDCO_LIST_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    // For get by id (edit)
    case types.GET_HOLDCO_BY_ID_REQUEST:
      return { ...state, isEditLoading: true, editError: null, holdCoEdit: null };
    case types.GET_HOLDCO_BY_ID_SUCCESS:
      return { ...state, isEditLoading: false, holdCoEdit: action.payload, editError: null };
    case types.GET_HOLDCO_BY_ID_FAILURE:
      return { ...state, isEditLoading: false, editError: action.payload };

    // For delete
    case types.DELETE_HOLDCO_REQUEST:
      return { ...state, isDeleting: true, deleteError: null, deleteSuccess: false };
    case types.DELETE_HOLDCO_SUCCESS:
      return { ...state, isDeleting: false, deleteSuccess: true, deleteError: null };
    case types.DELETE_HOLDCO_FAILURE:
      return { ...state, isDeleting: false, deleteError: action.payload, deleteSuccess: false };
    case types.RESET_DELETE_STATE:
      return { ...state, deleteSuccess: false, deleteError: null, isDeleting: false };

    // For delete file
    case types.DELETE_HOLDCO_FILE_REQUEST:
      return { ...state, isDeleting: true, deleteFileError: null, deleteFileSuccess: false };
    case types.DELETE_HOLDCO_FILE_SUCCESS:
      return { ...state, isDeleting: false, deleteFileError: null, deleteFileSuccess: true, deletedFileId: action.payload };
    case types.DELETE_HOLDCO_FILE_FAILURE:
      return { ...state, isDeleting: false, deleteFileError: action.payload, deleteFileSuccess: false };

    // For save
    case types.SAVE_HOLDCO_REQUEST:
      return { ...state, isSaving: true, saveError: null, saveSuccess: false };
    case types.SAVE_HOLDCO_SUCCESS:
      return { ...state, isSaving: false, saveSuccess: true, saveError: null, holdCoEdit: null };
    case types.SAVE_HOLDCO_FAILURE:
      return { ...state, isSaving: false, saveError: action.payload, saveSuccess: false };
    case types.RESET_SAVE_STATE:
      return { ...state, saveSuccess: false, saveError: null, isSaving: false, holdCoEdit: null };

    default:
      return state;
  }
};

export default HoldCoReducer;
